import { useCallback, useEffect, useState } from "react";
import FilialService from "../../services/resource/filialService";

const filialService = new FilialService();

const TIPOS_CATALOGO = ["STATUS", "DEPARTAMENTO", "TIPO_DISPOSITIVO", "MARCA", "MODELO", "OPERADORA"];

/**
 * Carrega, uma única vez por tela, tudo o que alimenta filtros e formulários do inventário:
 * metadados (campos por categoria, operações), cadastros auxiliares e filiais.
 */
export default function useOpcoesInventario(service) {
    const [estado, setEstado] = useState({
        carregando: true,
        metadados: null,
        catalogos: {},
        filiais: [],
    });

    const carregar = useCallback(async () => {
        try {
            const [metadados, filiais, ...catalogos] = await Promise.all([
                service.metadados(),
                filialService.listarAtivas(),
                ...TIPOS_CATALOGO.map(t => service.listarCatalogo(t)),
            ]);
            const porTipo = {};
            TIPOS_CATALOGO.forEach((t, i) => { porTipo[t] = catalogos[i].data || []; });
            setEstado({
                carregando: false,
                metadados: metadados.data,
                catalogos: porTipo,
                filiais: filiais.data || [],
            });
        } catch (e) {
            setEstado(prev => ({ ...prev, carregando: false }));
        }
    }, [service]);

    useEffect(() => {
        carregar();
    }, [carregar]);

    return { ...estado, recarregar: carregar };
}

/** Opções de catálogo para formulários: itens ativos + o item atualmente selecionado, mesmo inativo. */
export function opcoesDeCatalogo(itens = [], idAtual = null, filtro = null) {
    return itens
        .filter(i => (i.ativo || i.id === idAtual) && (!filtro || filtro(i)))
        .map(i => ({ value: i.id, label: i.ativo ? i.nome : `${i.nome} (inativo)` }));
}
